import { render, staticRenderFns } from "./category-info.vue?vue&type=template&id=13ad2878"
import script from "./category-info.vue?vue&type=script&lang=js"
export * from "./category-info.vue?vue&type=script&lang=js"
import style0 from "./category-info.vue?vue&type=style&index=0&id=13ad2878&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports